/* ==========================================================================
   <countdown-timer datetime="2026-05-15T18:00:00Z"></countdown-timer>
   Renders D / H / M / S split into 4 mono cells.
   ========================================================================== */

class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.targetMs = Date.parse(this.getAttribute('datetime') || '');
    if (Number.isNaN(this.targetMs)) {
      this.innerHTML = '';
      return;
    }
    this.render();
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  render() {
    const t = (window.theme && window.theme.t) || {};
    const lblD = t.countdown_days || 'Days';
    const lblH = t.countdown_hours || 'Hrs';
    const lblM = t.countdown_minutes || 'Min';
    const lblS = t.countdown_seconds || 'Sec';
    this.innerHTML = `
      <div class="countdown" role="timer" aria-live="off">
        <div class="countdown__cell"><span class="countdown__num" data-d>00</span><span class="countdown__lbl">${lblD}</span></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__cell"><span class="countdown__num" data-h>00</span><span class="countdown__lbl">${lblH}</span></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__cell"><span class="countdown__num" data-m>00</span><span class="countdown__lbl">${lblM}</span></div>
        <div class="countdown__sep">:</div>
        <div class="countdown__cell"><span class="countdown__num" data-s>00</span><span class="countdown__lbl">${lblS}</span></div>
      </div>`;
    this.elD = this.querySelector('[data-d]');
    this.elH = this.querySelector('[data-h]');
    this.elM = this.querySelector('[data-m]');
    this.elS = this.querySelector('[data-s]');
  }

  tick() {
    const now = Date.now();
    let diff = Math.max(0, this.targetMs - now);
    const d = Math.floor(diff / 86400000); diff -= d * 86400000;
    const h = Math.floor(diff / 3600000);  diff -= h * 3600000;
    const m = Math.floor(diff / 60000);    diff -= m * 60000;
    const s = Math.floor(diff / 1000);
    this.elD.textContent = String(d).padStart(2, '0');
    this.elH.textContent = String(h).padStart(2, '0');
    this.elM.textContent = String(m).padStart(2, '0');
    this.elS.textContent = String(s).padStart(2, '0');
    if (this.targetMs - now <= 0) {
      this.dispatchEvent(new CustomEvent('countdown:end', { bubbles: true }));
      clearInterval(this.interval);
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
